import { IUser } from './../model/user';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResult,ILookup, PageResult } from '../../../shared/model/Index';
import { IPageInfo } from '@app/shared/model/pageinfo';

@Injectable({ providedIn: 'root' })

export class LookupService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }
    getLookups1(pageInfo:IPageInfo):Observable<ILookup[]> {
        return this.http.post<ILookup[]>(env.apiUrl + 'lookup/GetLookupList',pageInfo);
    }
    getLookups(pageInfo:IPageInfo) {
        return this.http.post<ApiResult<ILookup[]>>(env.apiUrl + 'lookup/GetLookupList',pageInfo).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }  

    export(pageInfo:IPageInfo) {
        return this.http.post(env.apiUrl + 'lookup/export',pageInfo,{ responseType: 'blob'});
    }  

    getActiveLookups(tableName: string,majorDisciplineId:number=0) {
        return this.http.get<ApiResult<ILookup[]>>(env.apiUrl + 'lookup/Active/' + tableName+'/'+majorDisciplineId).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    getLookupById(id:number,tableName: string) {
        return this.http.get<ApiResult<ILookup>>(env.apiUrl + 'lookup/' + id+ '/'+ tableName).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    getLookupByCode(code: string,tableName: string) {
        return this.http.get<ApiResult<ILookup>>(env.apiUrl + 'lookup/Code/' + code+ '/'+ tableName).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    post(lookup: ILookup) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'lookup', lookup);
    }
    put(lookup: ILookup) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'lookup', lookup);
    }
    delete(id:number,tableName: string) {
        return this.http.delete<ApiResult<number>>(env.apiUrl + 'lookup/' + id+ '/'+ tableName);
    }
    getUsers(search:any) {
        return this.http.post<ApiResult<PageResult<IUser>>>(env.apiUrl + 'lookup/getusers',search).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
}